module.exports = __webpack_public_path__ + "img/De.2fdc24d3.png";